var getToken = function () {
    var token = localStorage.getItem("token");
    return token || undefined;
};
export { getToken };
